import React from 'react';
//import ReactDOM from "react-dom";
import ShopProfile from './shopProfile';
import '../mainCSS/breadcrumb.css';

export default class Breadcrumb extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null
        };
    }

    urlTag(tag) {
        //var asciiStr = tag.normalize('NFKD').replace(/[^\w]/g, '');
        var asciiStr = tag.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        asciiStr = asciiStr.replace(" ", "-");
        asciiStr = asciiStr.toLowerCase();
        return asciiStr;
    }

    mainPage() {
        return (
            <li>
                <a href={ShopProfile.getURL()}>
                    <span>
                        {'Kezdőlap'}
                    </span>
                </a>
            </li>
        );
    }

    allproductsPageLink() {
        return (
            <li>
                <a href={ShopProfile.getURL() + '/top/kellek'}>
                    <span>
                        {'Termékek'}
                    </span>
                </a>
            </li>
        );
    }

    mainCategoryPage() {
        return (
            <li>
                <b>fő kategoria</b>
            </li>
        );
    }

    mainCategoryPageLink(mainCategory, mainCategoryID) {
        var link = ShopProfile.getURL() + '/segedeszkoz/';
        link = link + mainCategoryID;
        link = link + '/' + this.urlTag(mainCategory);
        return (
            <li>
                <a href={link}>
                    <span>
                        {mainCategory}
                    </span>
                </a>
            </li>
        );
    }

    categoryPage(category, categoryID) {
        return (
            <li>
                <b>{category}</b>
            </li>
        );
    }

    /*categoryPageLink(category, categoryID) {
        return (
            <li itemprop={'itemListElement'} itemscope itemtype={'https://schema.org/ListItem'}>
                <a class={'last'} itemprop={'item'} href={ShopProfile.getURL() + '/" . _AL_MENU_ . "/' + ShopProfile.getCategoryID() + '/" . Tools::url_tag($item) . "'}><span itemprop='name'>{category}</span></a>
                <meta itemprop={'position'} content={'4'} />
            </li>
        );
    }*/

    breadCrumbShow(mainCategory, mainCategoryID, category, categoryID) {
        return (
            this.render(mainCategory, mainCategoryID, category, categoryID)
        );
    }

    render(mainCategory, mainCategoryID, category, categoryID) {
        const main = this.mainPage();
        const all = this.allproductsPageLink();
        const mainCat = this.mainCategoryPageLink(mainCategory, mainCategoryID);
        const cat = this.categoryPage(category, categoryID);
        return (
            <div id='breadcrumb'>
                <ol>
                    {main}
                    {all}
                    {mainCat}
                    {cat}
                </ol>
            </div>
        );
    }
}